.container {
  max-width: min(26rem, calc(100vw - 2 * var(--space-4)));
  pointer-events: none;
}

.notification {
  --notice-accent: var(--color-notice-info);
  --notice-surface: var(--color-card-blue);

  position: relative;
  overflow: hidden;
  padding: var(--space-4);
  border: 0.125rem solid var(--notice-accent);
  border-bottom-width: 0.3rem;
  border-radius: var(--radius-lg);
  color: var(--color-text-primary);
  background: var(--notice-surface);
  box-shadow: var(--shadow-block);
  pointer-events: auto;
}

.notification::before {
  display: none;
}

.notification[data-variant='success'] {
  --notice-accent: var(--color-notice-success);
  --notice-surface: var(--color-card-green);
}

.notification[data-variant='error'] {
  --notice-accent: var(--color-notice-error);
  --notice-surface: var(--color-card-pink);
}

.notification[data-variant='info'] {
  --notice-accent: var(--color-notice-info);
  --notice-surface: var(--color-card-blue);
}

.notification :global(.mantine-Notification-title) {
  margin-bottom: var(--space-1);
  color: var(--color-text-primary);
  font-family: var(--font-family-display);
  font-size: 0.875rem;
  font-weight: 750;
  line-height: 1.35;
}

.notification :global(.mantine-Notification-description) {
  color: var(--color-text-primary);
  font-size: 0.875rem;
  line-height: 1.5;
}

.notification :global(.mantine-Notification-icon) {
  color: var(--color-surface-raised);
  background: var(--notice-accent);
  border-radius: var(--radius-md);
}

.notification :global(.mantine-Notification-closeButton) {
  color: var(--color-text-primary);
  border-radius: var(--radius-sm);
}

.notification :global(.mantine-Notification-closeButton):focus-visible {
  outline: 0.125rem solid var(--color-focus);
  outline-offset: 0.125rem;
}

@media (max-width: 35.99em) {
  .container {
    top: 0;
    bottom: auto;
    right: 0;
    left: 0;
    width: 100%;
    max-width: none;
    padding-top: env(safe-area-inset-top);
    transform: none;
  }

  .notification {
    width: 100%;
    border-right: 0;
    border-left: 0;
    border-top: 0;
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  }
}
